<template>
  <Bar
    :data="finalChartData"
    :options="finalChartOptions"
  />
</template>

<script lang="ts">
import 'chart.js/auto'
import { Bar } from 'vue-chartjs'
import {
  type ChartOptions,
  type ChartData as FinalChartData
} from 'chart.js/auto'
import exportedColors from '~/assets/style/_exportDefaultChartColors.module.scss'
import type { TrendChartData } from '~/types/analytics'
import { DEFAULT_CHART_OPTIONS } from '~/constants/chart'

const BORDER_RADIUS = 4

export default {
  name: 'TrendRatio',
  components: { Bar },
  props: {
    chartData: {
      type: Object as PropType<TrendChartData>,
      required: true
    }
  },
  computed: {
    finalChartOptions(): ChartOptions<'bar'> {
      return {
        ...DEFAULT_CHART_OPTIONS,
        scales: { x: { display: false }, y: { display: false } },
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: false
          }
        }
      }
    },
    finalChartData(): FinalChartData<'bar'> {
      const colors = Object.values(exportedColors)
      return {
        ...this.chartData,
        datasets: this.chartData.datasets.map((dataset, i) => {
          const color = colors[i]

          return {
            ...dataset,
            yAxisID: 'y',
            backgroundColor: color,
            borderRadius: {
              topLeft: BORDER_RADIUS,
              topRight: BORDER_RADIUS,
              bottomLeft: BORDER_RADIUS,
              bottomRight: BORDER_RADIUS
            },
            borderSkipped: false
          }
        })
      }
    }
  }
}
</script>
